import * as React from 'react'
export const SvgRewardPoints = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={39} height={40} {...props}>
    <path d="M21.45 28c3.23 0 5.85-2.686 5.85-6s-2.62-6-5.85-6c-3.23 0-5.85 2.686-5.85 6s2.62 6 5.85 6zm0 2c-4.308 0-7.8-3.582-7.8-8s3.492-8 7.8-8 7.8 3.582 7.8 8-3.492 8-7.8 8z" />
    <path d="M15.732 26.782c-3.43-.84-5.982-4.006-5.982-7.782 0-4.418 3.492-8 7.8-8 2.814 0 5.28 1.529 6.652 3.82l-1.662 1.047C21.482 14.098 19.61 13 17.55 13c-3.23 0-5.85 2.686-5.85 6 0 2.792 1.875 5.197 4.485 5.836l-.453 1.946zM22.425 18h1.95l-3.9 8h-1.95z" />
  </svg>
)
export default SvgRewardPoints
